import colorsVars from 'styles/colors.module.scss';

import { Pagination } from 'components/common/pagination/customPagination';

const { activityLevelDriversLight, activityLevelDriversDark } = colorsVars;

export const PER_PAGE = 10;

export const impactTypeOptions: ISelectOption<'DAYS' | 'CORRELATION'>[] = [
    { label: 'Correlation Index', value: 'CORRELATION' },
    { label: 'Days', value: 'DAYS' },
];

export const exportCsvHeaders = ({ impactType }: { impactType: ISelectOption<'DAYS' | 'CORRELATION'> }) => [
    {
        key: 'activityId',
        name: 'Activity Id',
    },
    {
        key: 'activityName',
        name: 'Activity Name',
    },
    {
        key: 'impactValue',
        name: `Impact (${impactType.label})`,
    },
];

export const options = ({ data, themeStatus, dataPointSelection }): ApexCharts.ApexOptions => ({
    plotOptions: {
        bar: {
            horizontal: true,
        },
    },
    colors: themeStatus ? [activityLevelDriversLight] : [activityLevelDriversDark],
    chart: {
        background: themeStatus ? '#000000' : '#ffffff',
        foreColor: themeStatus ? '#FEFEFE' : '#000000',
        toolbar: {
            show: false,
        },
        events: {
            xAxisLabelClick: (_event, _chartContext, options) => {
                dataPointSelection({ dataPointIndex: options.labelIndex });
            },
        },
    },

    xaxis: {
        categories: data.map((item) => `${item.activityName} (${item.activityId})`),
        tickAmount: 10,
        labels: {
            style: {
                fontFamily: 'Roboto',
                fontSize: '14px',
            },
        },
    },
    yaxis: {
        labels: {
            minWidth: 600,
            maxWidth: 600,
            align: 'left',
            style: {
                fontFamily: 'Roboto',
                fontSize: '16px',
                cssClass: 'custom-label',
            },
        },
    },
    legend: {
        itemMargin: {
            horizontal: 10,
            vertical: 25,
        },
        fontSize: '14px',
        fontFamily: 'Roboto',
    },
    tooltip: {
        style: {
            fontFamily: 'Roboto',
            fontSize: '14px',
        },
    },
});

export const series = ({ data }) => [
    {
        data: data.map((item) => item.impactValue),
    },
];

export const getPageData = <T>({ data, pagination }: { data: T[]; pagination: Pagination }) => {
    return data.slice((pagination.page - 1) * pagination.size, pagination.page * pagination.size) ?? [];
};
